import React from "react";
const getBrandedDeviceName = (device: string) => {
  if (device.toLowerCase().includes("cough")) {
    return (
      <>
        BiWaze<sup>®</sup> Cough
      </>
    );
  }
  if (device.toLowerCase().includes("clear")) {
    return (
      <>
        BiWaze<sup>®</sup> Clear
      </>
    );
  }
  return device;
};
export { getBrandedDeviceName };